import { ActionBase } from '../../../core/store/action/ActionBase';

export const FINALIZE_CODESYSTEMVERSION_DRAFT = '[Vocabulary] Finalize CodeSystemVersion Draft';

export class FinalizeCodeSystemVersionDraftAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = FINALIZE_CODESYSTEMVERSION_DRAFT;

  constructor(public payload: { key: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/vocabulary/store/actions/FinalizeCodeSystemVersionDraftAction.ts